export default __webpack_public_path__ + "geburtstag-chat-03.fb3d1a3fce9ed1bf7c433bacd6f03256.png";